import React, { MouseEvent, useState } from 'react';
import Truncate from 'react-text-truncate';

import styles from './TruncateText.module.css';
/** Accepts everything `TextStyle` does, so callers can pass `aria-hidden`, `id`, `role` and the like. */
interface Props extends Omit<React.HTMLAttributes<HTMLElement>, 'children'> {
  children: string;
  lines: number;
  disableShowMoreButton?: boolean;
  showMoreButtonText?: string;
  textStyle: React.FunctionComponent<React.HTMLAttributes<HTMLElement>>;
}

export const TruncateText: React.FunctionComponent<Props> = React.memo(
  ({
    children,
    lines,
    className,
    itemProp,
    disableShowMoreButton,
    textStyle: TextStyle,
    showMoreButtonText = 'Les mer',
    ...rest
  }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleLines = (event: MouseEvent) => {
      event.preventDefault();
      setExpanded(!expanded);
    };

    return (
      <TextStyle {...rest} className={className} itemProp={itemProp}>
        <Truncate
          element="span"
          line={!expanded && lines}
          text={children}
          containerClassName="common-truncate-text"
          textTruncateChild={
            <>
              {!disableShowMoreButton && (
                <button className={`rds-link ${styles.truncateButtonReset}`} onClick={toggleLines}>
                  {showMoreButtonText}
                </button>
              )}
            </>
          }
        />
      </TextStyle>
    );
  }
);
